import { Controller } from "@hotwired/stimulus"

// Bouton « œil » accolé à un champ mot de passe (.input-group) : affiche ou masque la saisie.
export default class extends Controller {
  toggle() {
    const input = this.element.closest(".input-group")?.querySelector("input")
    if (input) input.type = input.type === "password" ? "text" : "password"
  }
}
